<template>
  <div>
    <div><img src="../../assets/about/companybg.png" class="fruit_img" /></div>
    <div style="" class="banner">公司介绍</div>
    <div class="line"></div>
    <div class="content">
      杭州宣胜焊接设备有限公司成立于2010年，位于美丽的西子湖畔杭州，是一家专业从事PE，HDPE，PPR热塑性管道工程机械的厂家，具有技术先进，功能实用，产品通过CE认证，深受国内外客户的好评。
      经过十多年的发展，公司拥有铸造，精加工，喷塑，钣金，包装等全产业链配套车间，目前已有产品包括2000mm及以下全系列的热熔对焊机、全自动燃气对焊机、全自动电热熔焊机、管件热熔对接机、塑料管道切割工具，以及各种施工专用辅助工具等产品。
      产品畅销全国30多个省，自治区，并出口到中东，东欧，东南亚，中亚等非洲国家。
      公司秉承“真诚合作，用户至上，吸收发展，勇于创新”的企业精神，凭借先进的管理模式、创新的技术优势及制造加工、资金的综合实力，愿与客户精诚合作，建立良好的商业信誉，
      面向新老客户的需求，产品远销世界各地！
    </div>
    <div style="" class="banner">企业文化</div>
    <div class="line"></div>
    <div class="content">
      求精：精益求精、追求卓越是宣胜竞争发展的品牌资本，是宣胜用户至上的服务精神，也是员工职业发展的持续指引<br />
      真诚：求真务实、诚实守信是宣胜经营的基本商业准则，我们在面对客户、员工及商业伙伴时，要恪守正直坦诚，强调勇于担当，确保言行一致，做到信守承诺。<br />
      创新：勇于创新、敢于突破是宣胜保持核心竞争力的源泉，是持续发展的不竭动力。<br />
      学习：志存高远、持续学习是宣胜发展的重要基础，提倡主动学习、向实践学习、向标杆学习，鼓励员工把学习作为终身的乐趣和成就。
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
};
</script>

<style scoped>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
.banner {
  font-size: 36px;
  font-weight: bold;
  margin-top: 80px;
  text-align: center;
}
.line{
    width: 60px;
    height: 5px;
    background: #df002e;
    margin: 6px auto;
}


.fruit_img {
  height: 550px;
  width: 100%;
}
.content {
  width: 80%;
  margin: 50px auto;
  padding: 20px;
  line-height: 50px;
  text-align: left;
  box-shadow: 3px 3px 10px #ccc;
  color: #737373;;
}

.flexStyle {
  display: flex;
  align-items: center;
}
/* 屏幕设备适配 max-device-width: 400px */
@media screen and (max-device-width: 415px) {
  .banner {
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    margin-top: 20px;
  }
  .fruit_img {
    height: 180px;
    width: 100%;
  }

  .flexStyle {
    display: none;
    align-items: center;
  }
  .content {
  width: 90%;
  margin: 20px auto;
  padding: 20px;
  line-height: 50px;
  text-align: left;
  box-shadow: 3px 3px 10px #ccc;
  color: #737373;;
}

}
</style>